import React, { useState } from 'react';
import { 
  FiUserPlus, 
  FiSearch, 
  FiEdit2, 
  FiTrash2, 
  FiLock,
  FiShield,
  FiMoreVertical,
  FiCheck,
  FiX
} from 'react-icons/fi';

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc'
  };

  const users = [
    { id: 1, name: 'अमित कुमार', role: 'सुपर प्रशासक', mobile: '९८७६५४३२१०', email: 'admin@mahagram.gov.in', status: 'सक्रिय' },
    { id: 2, name: 'स्नेहा पाटील', role: 'ब्लॉक प्रशासक', mobile: '९८७६५४११२२', email: 'bdo.ambegaon@mahagram.gov.in', status: 'सक्रिय' },
    { id: 3, name: 'रमेश चव्हाण', role: 'डेटा एन्ट्री ऑपरेटर', mobile: '८८८७७७६६५५', email: 'deo.shirpur@mahagram.gov.in', status: 'अक्षम' },
    { id: 4, name: 'सुप्रिया देसाई', role: 'ग्रामपंचायत प्रशासक', mobile: '९९८८७७६६५५', email: 'gp.malegaon@mahagram.gov.in', status: 'सक्रिय' },
  ];

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>वापरकर्ता व्यवस्थापन</h1>
          <p className="text-gray-600 text-sm">प्रणाली वापरकर्ते, भूमिका आणि परवानग्या व्यवस्थापित करा.</p>
        </div>
        <button 
          className="mt-4 md:mt-0 px-6 py-2.5 text-white font-medium rounded-lg shadow-md hover:opacity-90 transition-all flex items-center"
          style={{ backgroundColor: colors.primary }}
        >
          <FiUserPlus className="mr-2" /> नवीन वापरकर्ता
        </button>
      </div>

      {/* Filter Bar */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex items-center justify-between">
         <div className="relative w-full max-w-md">
            <FiSearch className="absolute left-3 top-3 text-gray-400" />
            <input 
              type="text"
              placeholder="नाव, मोबाईल किंवा ईमेल शोधा..."
              className="w-full pl-10 p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
         </div>
      </div>

      {/* Users Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 text-gray-700 text-sm">
                 <th className="p-4 font-semibold border-b">अ.क्र.</th>
                 <th className="p-4 font-semibold border-b">वापरकर्ता नाव</th>
                 <th className="p-4 font-semibold border-b">भूमिका (Role)</th>
                 <th className="p-4 font-semibold border-b">संपर्क तपशील</th>
                 <th className="p-4 font-semibold border-b text-center">स्थिती</th>
                 <th className="p-4 font-semibold border-b text-center">कृती</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {users.map((user, index) => (
                <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 text-gray-500">{index + 1}</td>
                  <td className="p-4 font-medium text-gray-800">
                    <div className="flex items-center">
                      <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center font-bold mr-3">
                        {user.name.charAt(0)}
                      </div>
                      {user.name}
                    </div>
                  </td>
                  <td className="p-4">
                    <span className="flex items-center text-gray-700 bg-gray-100 px-3 py-1 rounded-full text-xs font-semibold w-fit">
                      <FiShield className="mr-1.5 text-gray-500" size={12} /> {user.role}
                    </span>
                  </td>
                  <td className="p-4 text-gray-600 text-xs">
                     <div className="mb-1">📧 {user.email}</div>
                     <div>📱 {user.mobile}</div>
                  </td>
                  <td className="p-4 text-center">
                    {user.status === 'सक्रिय' ? (
                       <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-bold flex items-center justify-center w-20 mx-auto">
                         <FiCheck className="mr-1" /> सक्रिय
                       </span>
                    ) : (
                       <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-bold flex items-center justify-center w-20 mx-auto">
                         <FiX className="mr-1" /> अक्षम
                       </span>
                    )}
                  </td>
                  <td className="p-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <button className="p-2 text-blue-600 hover:bg-blue-50 rounded" title="संपादित करा">
                        <FiEdit2 size={16} />
                      </button>
                      <button className="p-2 text-yellow-600 hover:bg-yellow-50 rounded" title="पासवर्ड बदला">
                        <FiLock size={16} />
                      </button>
                      <button className="p-2 text-red-600 hover:bg-red-50 rounded" title="अक्षम करा">
                        <FiTrash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
